import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as ResumeCouple } from "../../../../assets/resumeCouple.svg";
import { LandingPageImage } from "../landingPageImage";
import {
  MobileView,
  SingleViewPerLayoutBreakPoint,
} from "../../../../util/aKaunGeneralUtil";
import { RosebudMobileBottomNavigationHeight } from "../../common/rosebudButtomNavigationButton";
import { LandingPageMessage } from "../landingPageMessage";
import { DeviceStoreIcon } from "fe-common/ui/icons/deviceStoreIcon";

//region [[ Styles ]]

const WelcomeBackTopSectionView = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexFlow: "row",
  [theme.breakpoints.up(MobileView)]: {
    height: "25vh",
  },
  [theme.breakpoints.up(SingleViewPerLayoutBreakPoint)]: {
    height: "40vh",
    alignContent: "flex-start",
  },
}));

const WelcomeBackTextContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexFlow: "column",
  justifyContent: "center",
}));

const WelcomeBackImage = styled(LandingPageImage)(({ theme }) => ({
  marginTop: "30px",
  [theme.breakpoints.up(MobileView)]: {
    "& svg": {
      height: `calc(100vh - ${RosebudMobileBottomNavigationHeight + 38}px)`,
      marginBottom: `-60vh`,
    },
  },
  [theme.breakpoints.down(MobileView)]: {
    marginTop: "5px",
    width: "40%",
    "& svg": {
      height: "271px",
      marginBottom: "-150px",
      marginRight: "0px",
    },
  },
}));

const WelcomeBackText = styled(LandingPageMessage)(({ theme }) => ({
  "& .main-title": {
    fontSize: "40px",
    lineHeight: "45px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: "25px",
      lineHeight: "28px",
      textAlign: "left",
    },
  },
  "& .description-text": {
    fontSize: "19px",
    lineHeight: "19px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: "14px",
      lineHeight: "19px",
      textAlign: "left",
      marginBottom: "6px",
    },
  },
  [theme.breakpoints.down(MobileView)]: {
    marginLeft: "10px",
  },
  flexGrow: 0,
}));

const StoreIcons = styled(DeviceStoreIcon)(({ theme }) => ({
  display: "flex",
  flexFlow: "row",
  margin: "0 5px",
  "& svg": {
    width: "110px",
  },
  "& svg:not(:last-of-type)": {
    marginRight: "15px",
  },
  justifyContent: "flex-start",
  flexWrap: "wrap",
  [theme.breakpoints.down(MobileView)]: {
    justifyContent: "center",
    margin: 0,
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]

export interface WelcomeBackTopSectionProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

//region [[ Texts ]]
const WELCOME_BACK_MAIN_TITLE = "Welcome Back!";
const WELCOME_BACK_DESC_TEXT = "How would you like to start?";
//endregion [[ Texts ]]

export const WelcomeBackTopSection = ({
  ...props
}: WelcomeBackTopSectionProps) => {
  return (
    <WelcomeBackTopSectionView>
      <WelcomeBackImage Image={ResumeCouple} />
      <WelcomeBackTextContainer>
        <WelcomeBackText
          mainTitle={WELCOME_BACK_MAIN_TITLE}
          descriptionText={WELCOME_BACK_DESC_TEXT}
        />
        <StoreIcons />
      </WelcomeBackTextContainer>
    </WelcomeBackTopSectionView>
  );
};
